import { render, staticRenderFns } from "./SalaryTemplates.vue?vue&type=template&id=406176e8"
import script from "./SalaryTemplates.vue?vue&type=script&lang=js"
export * from "./SalaryTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports